<template>
    <div>
        <v-container grid-list-xl fluid>
            <StoreStepper current="static_pages"></StoreStepper>
            <v-layout row wrap class="pt-2">
                <v-btn
                        round
                        @click="$router.push(`/pages/static_pages/new/` + $route.params.store_id)" color="blue"
                style="color: white"> + افزودن صفحه</v-btn>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="Name"
                                    select-all
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ props.item.page_id }}</td>
                                    <td class="text-xs-center">{{ props.item.title }}</td>
                                    <td class="text-xs-center">
                                        <v-btn depressed outline icon fab dark color="primary" @click="$router.push(`/pages/static_pages/edit/`+ $route.params.store_id+'/'+props.item.page_id)" small>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn depressed outline icon fab dark color="pink" @click="del(props.item.page_id)" small>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import StoreStepper from '@/components/StoreStepper';
export default {
  components: {
    StoreStepper
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'شناسه',
            value: 'page_id',
            align: 'center'
          },
          {
            text: 'عنوان',
            value: 'title',
            align: 'center'
          },
          {
            text: 'مدیریت',
            value: '',
            align: 'center'
          },
        ],
        items: []
      },
      stores: [],
    };
  },
  created: function () {
    this.pages();
  },
  mounted: function () {

    this.axios.get('/reseller/stores/')
      .then(response => {
        this.stores = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    del: function (id) {
      this.DeleteEntityPromise('store_pages', id).then(() => {
        this.pages();
      });
    },
    pages: function () {
      this.axios.get('/reseller/store_pages/' + this.$route.params.store_id)
        .then(response => {
          this.complex.items = response.data.Data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/static_pages/modify.vue